import {AppDispatch, store} from "../../store";
import {GameActionCreators} from "../../store/reducers/game/action-creators";
import CoreData from "./dispatches/CoreData";
import Resource from "./dispatches/Resource";
import HP from "./dispatches/HP";
import Table from "./dispatches/Table";
import UnitFight from "./dispatches/UnitFight";
import MiddlewareAbility from "./dispatches/MiddlewareAbility";
import CpuPlayedCard from "./dispatches/CpuPlayedCard";
import {sounds} from "../../sounds/sound";
import GameService from "../../api/GameService";
import Helper from "../Helper";
import {AuthActionCreators} from "../../store/reducers/auth/action-creators";
import Turn from "./dispatches/Turn";


export default class ServerStateDispatcher {


    private static runStackLoop: boolean = false;
    private static stateStack: any = [];

    static async processState(serverState, dispatch: AppDispatch, hardResetQueue: boolean = false) {

        if(hardResetQueue){
            ServerStateDispatcher.runStackLoop = false;
            await new Promise(r => setTimeout(r, 65));
            ServerStateDispatcher.stateStack = [{states: serverState, dispatch: dispatch}];
            ServerStateDispatcher.runStackLoop = true;
             ServerStateDispatcher.startStackLoop();
        }else {

            // @ts-ignore
            ServerStateDispatcher.stateStack.push({states: serverState, dispatch: dispatch});
        }

    }

    static stopStackLoop(){
        ServerStateDispatcher.runStackLoop = false;
    }

    static async startStackLoop() {

        ServerStateDispatcher.runStackLoop = true;
        while (ServerStateDispatcher.runStackLoop) {

            if (ServerStateDispatcher.stateStack.length === 0) {
                await new Promise(r => setTimeout(r, 50));
                continue;
            }

            const data = ServerStateDispatcher.stateStack.shift();

            for (let i = 0; i < Object.keys(data.states).length; i++) {

              const result =  await ServerStateDispatcher.dispatchState(data.states[i], data.dispatch);
              if(!result){
                  break;
              }
            }

            await new Promise(r => setTimeout(r, 50));
        }
    }

    static async dispatchState(serverState, dispatch: AppDispatch) {

        serverState = serverState.state;

        const state = store.getState();

        if (state.game.phase === 'end_game') {
            return;
        }

        if(serverState.skip_turn !== undefined && serverState.skip_turn === 1){
            dispatch(GameActionCreators.setPhase('enemy_turn'));

            try {
                const response = await GameService.endTurn(null, true);
                await GameActionCreators.processState(response.data, dispatch); // showCpuTurn
            } catch (e) {
                // @ts-ignore
                console.log('end turn error ' + e.message);
            }
            return false;
        }

        // Core Data ///
        if (serverState.end_game !== undefined) {
            await CoreData.endGame(serverState.end_game, dispatch);
        }
        if (serverState.phase !== undefined) {
            await CoreData.phase(serverState.phase, dispatch);
        }

        const actualState = store.getState();

        if (actualState.game.phase === 'end_game') {
           return;
        }


        if (serverState.cpu !== undefined) {
            await CoreData.cpu(serverState.cpu, dispatch);
        }
        if (serverState.game_data !== undefined) {
            await CoreData.gameData(serverState.game_data, dispatch);
        }

        if(serverState.counters !== undefined){
            await CoreData.counters(serverState.counters, dispatch);
        }

        /// Unit Fight //
        if (serverState.unit_fight !== undefined || serverState.unit_damage_to_player) {

            let state =  serverState.unit_fight;
            if(state === undefined){
                state = serverState.unit_damage_to_player;
            }
            await UnitFight.fight(state, dispatch);
        }

        /// Show MiddleWare Ability
        if (serverState.middleware_ability !== undefined) {
            await MiddlewareAbility.show(serverState.middleware_ability, dispatch);
        }

        /// Player ///
        if (serverState.player !== undefined && serverState.player.resources !== undefined && serverState.player.resources.fire !== undefined) {
            await Resource.set('Player', 'Fire', serverState.player.resources.fire, dispatch);
        }
        if (serverState.player !== undefined && serverState.player.resources !== undefined && serverState.player.resources.diamond !== undefined) {
            await Resource.set('Player', 'Diamond', serverState.player.resources.diamond, dispatch);
        }
        if (serverState.player !== undefined && serverState.player.resources !== undefined && serverState.player.resources.pow !== undefined) {
            await Resource.set('Player', 'Pow', serverState.player.resources.pow, dispatch);
        }

        if (serverState.player !== undefined && serverState.player.hp !== undefined) {
            await HP.set('Player', serverState.player.hp, dispatch);
        }
        if (serverState.player !== undefined && serverState.player.hand !== undefined) {
            dispatch(GameActionCreators.setPlayerHand(serverState.player.hand));
        }
        if (serverState.player !== undefined && serverState.player.table !== undefined) {

            await Table.set('player', serverState, dispatch);
        }

        if (serverState.player !== undefined && serverState.player.turn !== undefined) {

            await Turn.set(serverState.player.turn, dispatch);
        }

        if (serverState.player_played_card !== undefined) {
           await CpuPlayedCard.show(serverState.player_played_card, dispatch, true);
        }

        /// CPU ///
        if (serverState.cpu !== undefined && serverState.cpu.resources !== undefined && serverState.cpu.resources.fire !== undefined) {
            await Resource.set('Cpu', 'Fire', serverState.cpu.resources.fire, dispatch);
        }
        if (serverState.cpu !== undefined && serverState.cpu.resources !== undefined && serverState.cpu.resources.diamond !== undefined) {
            await Resource.set('Cpu', 'Diamond', serverState.cpu.resources.diamond, dispatch);
        }
        if (serverState.cpu !== undefined && serverState.cpu.resources !== undefined && serverState.cpu.resources.pow !== undefined) {
            await Resource.set('Cpu', 'Pow', serverState.cpu.resources.pow, dispatch);
        }
        if (serverState.cpu !== undefined && serverState.cpu.hp !== undefined) {
            await HP.set('Cpu', serverState.cpu.hp, dispatch);
        }
        if (serverState.cpu !== undefined && serverState.cpu.table !== undefined) {

            await Table.set('cpu', serverState, dispatch);
        }
        if (serverState.cpu !== undefined && serverState.cpu.data !== undefined) {

            dispatch(GameActionCreators.setCpuData(serverState.cpu.data));
        }

        /// CPU PLAYED CARD ///


        if (serverState.cpu_played_card !== undefined) {

            await CpuPlayedCard.show(serverState.cpu_played_card, dispatch);
            if( state.game?.game?.cpu_id === 21 && state.game.phase === 'enemy_turn') {
                await new Promise(r => setTimeout(r, Helper.getRandomNumber(1000, 2500)));
            }
        }


        if (serverState.cpu_start_turn !== undefined) {
          //  sounds.battle_end_turn().play();
            await new Promise(r => setTimeout(r, 1000));
            dispatch(GameActionCreators.setMessage({text: 'Enemy turn!', delay: 1400, type: 'enemy_turn'}));
            await new Promise(r => setTimeout(r, 1500));

            if( state.game?.game?.cpu_id === 21) {
                await new Promise(r => setTimeout(r, Helper.getRandomNumber(1000, 3000)));
            }

        }

        //END TURN LAST POINT
        if (serverState.cpu_end_turn !== undefined) {
            dispatch(GameActionCreators.setPlayerAD({0: false, 1: false, 2: false, 3: false, 4: false}));
            sounds.battle_start_turn().play();
            await new Promise(r => setTimeout(r, 200));

            let tutorial = state.auth.tutorial;
            // Tutorial battle step
            if (tutorial.isActive === false && (tutorial.step === 'EndTurnBattle45' || tutorial.step === 'EndTurnBattle55' || tutorial.step === 'EndTurnBattle65')) {
                await new Promise(r => setTimeout(r, 200));

                tutorial.isActive = true;

                if (tutorial.step === 'EndTurnBattle45') {
                    tutorial.step = 'PlaySecondCard50';
                }

                if (tutorial.step === 'EndTurnBattle65') {
                    tutorial.step = 'PlaySpellCard70';
                }

                if (tutorial.step === 'EndTurnBattle55') {
                    tutorial.step = 'SelectAttack60';
                    // tutorial.step = 'EndTurnBattle65';
                }

                AuthActionCreators.setTutorial(tutorial);
            }
            //
        }

        return true;
    }
}